import { ActionIcon, Box, Menu } from '@mantine/core';
import { IconBook, IconExternalLink, IconHelp, IconMessageCircle } from '@tabler/icons-react';
import { useDispatch } from 'react-redux';
import { setChatOpen } from '../../store/chatSlice';

const GetHelpButton = ({ guideDonePercent, onGuideClick }) => {
  const dispatch = useDispatch();

  return (
    <Box display="inline-block" data-tour="helpDropdown">
      <Menu position="bottom-end">
        <Menu.Target>
          <ActionIcon variant="filled" size="lg" radius="xl" aria-label="Get Help">
            <IconHelp size={20} />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown>
          {onGuideClick && (
            <>
              <Menu.Item leftSection={<IconBook size={16} />} onClick={onGuideClick}>
                How-to Guide ({guideDonePercent}% complete)
              </Menu.Item>
              <Menu.Divider />
            </>
          )}
          <Menu.Item leftSection={<IconMessageCircle size={16} />} onClick={() => dispatch(setChatOpen(true))}>
            Ask a Question
          </Menu.Item>
          <Menu.Item
            component="a"
            href="https://releva.ai/documentation/category/user-guide/"
            target="_blank"
            rel="noopener noreferrer"
            leftSection={<IconExternalLink size={16} />}
          >
            Documentation
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </Box>
  );
};

export default GetHelpButton;
